import React, { useState } from 'react';
import { FiEdit2, FiTrash2 } from 'react-icons/fi';
import {
  useGetDomainesQuery,
  useAddDomaineMutation,
  useUpdateDomaineMutation,
  useDeleteDomaineMutation
} from '../../redux/api/coachApi';

const DomainesView = () => {
  const [newDomaine, setNewDomaine] = useState({ name: '' });
  const [editingDomaine, setEditingDomaine] = useState(null);
  const [error, setError] = useState('');

  const { data: domaines, isLoading, error: fetchError } = useGetDomainesQuery();
  const [addDomaine, { isLoading: isAdding }] = useAddDomaineMutation();
  const [updateDomaine, { isLoading: isUpdating }] = useUpdateDomaineMutation();
  const [deleteDomaine, { isLoading: isDeleting }] = useDeleteDomaineMutation();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!newDomaine.name.trim()) {
      setError('Le nom du domaine est requis.');
      return;
    }
    setError('');
    try {
      if (editingDomaine) {
        await updateDomaine({ id: editingDomaine.id, ...newDomaine }).unwrap();
      } else {
        await addDomaine(newDomaine).unwrap();
      }
      setNewDomaine({ name: '' });
      setEditingDomaine(null);
    } catch (err) {
      setError(editingDomaine
        ? "Erreur lors de la mise à jour du domaine."
        : "Erreur lors de l'ajout du domaine."
      );
      console.error("Error submitting domaine:", err);
    }
  };

  const handleEdit = (domaine) => {
    setEditingDomaine(domaine);
    setNewDomaine({ name: domaine.name });
  };

  const handleDelete = async (id) => {
    if (window.confirm('Êtes-vous sûr de vouloir supprimer ce domaine ?')) {
      try {
        await deleteDomaine(id).unwrap();
      } catch (err) {
        setError("Erreur lors de la suppression du domaine.");
        console.error("Error deleting domaine:", err);
      }
    }
  };

  if (isLoading) {
    return <div className="text-center py-6 text-gray-500"> Chargement des domaines...</div>;
  }

  if (fetchError) {
    return <div className="text-red-500 text-center"> Erreur lors du chargement des domaines</div>;
  }

  return (
    <div className="w-full max-w-4xl mx-auto p-6 space-y-6">
      
      {/* Formulaire */}
      <div className="bg-white shadow-lg rounded-2xl p-6 ">
        <h2 className="text-xl font-semibold text-teal-600 mb-4">
          {editingDomaine ? ' Modifier le Domaine' : ' Ajouter un Domaine'}
        </h2>  
        
        {error && <p className="text-red-500 text-sm mb-3">{error}</p>}
        
        <form onSubmit={handleSubmit} className="flex flex-wrap gap-3">
          <input
            type="text"
            className="flex-1 border border-gray-300 rounded-xl px-4 py-2 focus:ring-2 focus:ring-teal-500 outline-none"
            placeholder="Entrez le nom du domaine"
            value={newDomaine.name}
            onChange={(e) => setNewDomaine({ ...newDomaine, name: e.target.value })}
          />
          <button
            type="submit"
            className="bg-teal-600 hover:bg-teal-700 text-white px-6 py-2 rounded-xl shadow-md transition"
            disabled={isAdding || isUpdating}
          >
            {editingDomaine ? 'Mettre à jour' : 'Ajouter'}
          </button>
        </form>
      </div>

      {/* Liste */}
      <div className="bg-white shadow-lg rounded-2xl p-6">
        <h2 className="text-xl font-semibold text-teal-600 mb-4"> Liste des Domaines</h2>
        {domaines && domaines.length > 0 ? (
          <ul className="space-y-3">
            {domaines.map((domaine) => (
              <li key={domaine.id} className="flex items-center justify-between bg-gray-50 p-3 rounded-xl hover:bg-gray-100 transition">
                <span className="font-medium text-gray-700">{domaine.name}</span>
                <div className="flex gap-3">
                  <button
                    className="text-blue-500 hover:text-blue-700"
                    onClick={() => handleEdit(domaine)}
                  >
                    <FiEdit2 size={18} />
                  </button>
                  <button
                    className="text-red-500 hover:text-red-700"
                    onClick={() => handleDelete(domaine.id)}
                  >
                    <FiTrash2 size={18} />
                  </button>
                </div>
              </li>
            ))}
          </ul>
        ) : (
          <p className="text-gray-500">Aucun domaine trouvé.</p>
        )}
      </div>
    </div>
  );
};

export default DomainesView;
